function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.766 317.769",
    style: {
      enableBackground: "new 0 0 315.766 317.769"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M309.764 46.247 292.18 63.506l17.585 38.321v114.708l-21.665 27.79 21.665 27.79v20.104c0 9.78-7.959 17.738-17.738 17.738H25.95c-9.78 0-17.738-7.959-17.738-17.738V26.143c0-9.78 7.959-17.738 17.738-17.738h266.076c9.78 0 17.738 7.959 17.738 17.738v20.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M309.764 46.247 292.18 63.506l17.585 38.321v114.708l-21.665 27.79 21.665 27.79v20.104c0 9.78-7.959 17.738-17.738 17.738h-147.23V8.405h147.229c9.78 0 17.738 7.959 17.738 17.738v20.104z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 144.797,
    cy: 159.182,
    r: 27.79
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M144.797 186.972v-55.58c15.326 0 27.79 12.464 27.79 27.79s-12.464 27.79-27.79 27.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M234.672 150.312h-24.846c-3.95-29.109-27.051-52.21-56.16-56.16V69.307c0-4.896-3.973-8.869-8.869-8.869s-8.869 3.973-8.869 8.869v24.846c-29.109 3.95-52.21 27.051-56.16 56.16H54.922c-4.896 0-8.869 3.973-8.869 8.869s3.973 8.869 8.869 8.869h24.846c3.95 29.109 27.051 52.21 56.16 56.16v24.846c0 4.896 3.973 8.869 8.869 8.869s8.869-3.973 8.869-8.869v-24.846c29.109-3.95 52.21-27.051 56.16-56.16h24.846c4.896 0 8.869-3.973 8.869-8.869s-3.973-8.87-8.869-8.87zm-89.875 56.763c-26.407 0-47.894-21.487-47.894-47.894s21.487-47.894 47.894-47.894 47.894 21.487 47.894 47.894-21.487 47.894-47.894 47.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M243.541 159.182c0 4.896-3.973 8.869-8.869 8.869h-24.846c-3.95 29.109-27.051 52.21-56.16 56.16v24.846c0 4.896-3.973 8.869-8.869 8.869v-50.85c26.407 0 47.894-21.487 47.894-47.894s-21.487-47.894-47.894-47.894v-50.85c4.896 0 8.869 3.973 8.869 8.869v24.846c29.109 3.95 52.21 27.051 56.16 56.16h24.846c4.896-.001 8.869 3.973 8.869 8.869zm66.223-112.935v55.58h-47.302c-9.78 0-17.738-7.959-17.738-17.738V63.985c0-9.78 7.959-17.738 17.738-17.738h47.302zm0 170.289v55.58h-47.302c-9.78 0-17.738-7.959-17.738-17.738v-20.104c0-9.78 7.959-17.738 17.738-17.738h47.302z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultIcon);
export default __webpack_public_path__ + "static/media/VaultIcon.97c1865a906229917e3fb87c2a238497.svg";
export { ForwardRef as ReactComponent };